export default __webpack_public_path__ + "static/media/calendar.1f2e958e.svg";